import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import {
  Avatar,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { SourcingStatusTag } from "components/ui/atoms/Tag";

const SourcingListItemShort = ({ object: sourcing, primaryClick }) => {
  return (
    <ListItemButton onClick={() => primaryClick(sourcing)}>
      <ListItemAvatar variant="small">
        <Avatar
          src={`http://logo.clearbit.com/${sourcing.company_detail.best_domain}`}
        >
          <ApartmentSharpIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={sourcing.company_detail.best_name}
        secondary={sourcing.deal_flow_detail.name}
      />
      <ListItemText
        primary={<SourcingStatusTag status={sourcing.status} />}
        sx={{ flexShrink: 0, flexGrow: 0, ml: 1 }}
      />
    </ListItemButton>
  );
};

export default SourcingListItemShort;
